import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faStar } from '@fortawesome/pro-solid-svg-icons';
import Tooltip from 'components/tooltip';

import { formatDate } from 'helpers/formatters/date_time_formats';
import { USD } from 'helpers/formatters/number_formats';

import TiersTable from './tiers_table';
import ScheduleModal from './modal';

export function ScheduleRow({ isParentCompanyUser, royaltySchedule }) {
  const [showModal, setShowModal] = useState();

  const tiersTable = <TiersTable royaltySchedule={royaltySchedule} />;
  const getCurrentTierPercentage = (royaltySchedule) => {
    const ytd = royaltySchedule.filedCommissionAmountYearToDate;
    const currentTier = royaltySchedule.tiers.find(
      tier => ytd >= tier.from && (tier.to === null || ytd < tier.to)
    );
    return currentTier ? `${currentTier.royaltyPercentage}%` : '';
  };

  return (
    <React.Fragment>
      <tr>
        {isParentCompanyUser &&
          <React.Fragment>
            <td>
              {royaltySchedule.name || '--'}
              {royaltySchedule.companyDefault && (
                <Tooltip content="Company Default" dark>
                  <FontAwesomeIcon className="company-default-icon" fixedWidth icon={faStar} size="sm" />
                </Tooltip>
              )}
            </td>
            <td>
              <Tooltip content={tiersTable} overlayClassName="tiers-table-popover" rootClose trigger="click">
                <span className="tooltip-link">{royaltySchedule.royaltyPatternLabel}</span>
              </Tooltip>
            </td>
          </React.Fragment>}
        <td className="text-center">
          <Tooltip content={tiersTable} overlayClassName="tiers-table-popover" rootClose trigger="click">
            <span className="tooltip-link">{royaltySchedule.tiers.length}</span>
          </Tooltip>
        </td>
        <td className="text-center">{royaltySchedule.numberOfAgents}</td>
        <td className="text-center">{royaltySchedule.numberOfAgentsPaid}</td>
        <td className="text-right">{USD.format(royaltySchedule.filedCommissionAmountYearToDate)}</td>
        <td className="text-right">{getCurrentTierPercentage(royaltySchedule)}</td>
        {isParentCompanyUser &&
          <React.Fragment>
            <td className="text-center">{formatDate(royaltySchedule.updatedAt)}</td>
            <td className="actions" width="1">
              <a className="clickable" name="show-modal-link" onClick={() => setShowModal(true)}>
                <FontAwesomeIcon fixedWidth icon={faEdit} /> Edit
              </a>
            </td>
          </React.Fragment>}
      </tr>
      <ScheduleModal royaltySchedule={royaltySchedule} show={showModal} onClose={() => setShowModal(false)} />
    </React.Fragment>
  );
}

ScheduleRow.propTypes = {
  isParentCompanyUser: PropTypes.bool,
  royaltySchedule: PropTypes.shape({
    companyDefault: PropTypes.bool,
    filedCommissionAmountYearToDate: PropTypes.number,
    name: PropTypes.string,
    numberOfAgents: PropTypes.number,
    numberOfAgentsPaid: PropTypes.number,
    royaltyPatternLabel: PropTypes.string,
    tiers: PropTypes.array,
    updatedAt: PropTypes.string,
  }).isRequired,
};

export default ScheduleRow;
